module.exports = __webpack_public_path__ + "img/imgImgHome08.f8b1f8ef.svg";